// import Swiper JS
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar]);

var postSlider = new Swiper('.common-post-slider', {
  slidesPerView: 1,
  spaceBetween: 24,
  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  // scrollbar: {
  //   el: '.swiper-scrollbar',
  //   hide: false,
  // },
  breakpoints: {
    540: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
    },
  }
  // Navigation arrows
  // navigation: {
  //   nextEl: '.swiper-button-next',
  //   prevEl: '.swiper-button-prev',
  // }
});
